<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate class="port-form">
  <div class="form-group">
    <label for="port-type">Тип</label>

    <select
      id="port-type"
      class="form-control"
      formControlName="type"
      [attr.aria-disabled]="isTypeLocked"
    >
      @for (t of portTypes; track t.value) {
        <option [value]="t.value">{{ t.label }}</option>
      }
    </select>

    @if (isTypeLocked) {
      <small class="field-hint">
        Тип нельзя изменить после создания. Для смены типа удалите и создайте
        заново.
      </small>
    }
  </div>

  <div class="form-group">
    <label for="port-name">Название</label>

    <input
      id="port-name"
      type="text"
      class="form-control"
      formControlName="name"
      autocomplete="off"
      autocorrect="off"
      spellcheck="false"
      [attr.aria-invalid]="isInvalid('name')"
      [attr.aria-describedby]="isInvalid('name') ? 'port-name-error' : null"
    />

    <small id="port-name-error" class="field-error" *ngIf="isInvalid('name')">
      Укажите название
    </small>
  </div>

  <div class="form-group">
    <label for="port-number">Номер порта</label>

    <input
      id="port-number"
      type="number"
      class="form-control"
      formControlName="portNumber"
      min="0"
      step="1"
      inputmode="numeric"
      [attr.aria-invalid]="isInvalid('portNumber')"
      [attr.aria-describedby]="
        isInvalid('portNumber') ? 'port-number-error' : null
      "
    />

    <small
      id="port-number-error"
      class="field-error"
      *ngIf="isInvalid('portNumber')"
    >
      Укажите номер порта
    </small>
  </div>

  <div class="form-group form-group-inline">
    <div class="form-group-label">
      <label for="port-active">Активен</label>
      <small class="field-hint">Флаг активности порта</small>
    </div>

    <app-ios-switch
      [checked]="activeValue"
      thumbDot="red-green"
      ariaLabel="Активность порта"
      [title]="activeValue ? 'Выключить' : 'Включить'"
      (checkedChange)="onActiveChange($event)"
    ></app-ios-switch>
  </div>

  <div class="form-actions">
    <button type="button" class="btn btn-outline" (click)="onCancel()">
      Отмена
    </button>

    <button type="submit" class="btn btn-primary" [disabled]="form.invalid">
      {{ isEdit ? 'Сохранить' : 'Создать' }}
    </button>
  </div>
</form>
